import { Quote } from "lucide-react";
import Reveal from "./Reveal";

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-24 lg:py-32 bg-white border-y border-border" data-testid="testimonials-section">
      <div className="container-luxe">
        <Reveal className="max-w-2xl mx-auto text-center border border-gold/40 bg-gold-light rounded-sm px-8 py-14">
          <Quote className="w-10 h-10 text-gold mx-auto" />
          <h2 className="mt-6 font-serif text-3xl sm:text-4xl text-navy font-semibold">Client Testimonials</h2>
          <p className="mt-4 font-serif italic text-2xl text-navy/70">"Client testimonials coming soon."</p>
          <p className="mt-4 text-body text-sm leading-relaxed">
            We publish only genuine client reviews. Until then, call us directly and judge us for yourself.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
